import { CommonModule, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgbDropdownModule, NgbModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';

import { ButtonComponent } from 'mbs-ui-kit';

import { RmmDateTimeFormatModule } from 'mbs-ui-shared@components/date-time-format/rmm-date-time-format.module';
import { AutoRenewalAlertComponent } from 'mbs-ui-shared@components/licenses/components/auto-renewal-alert/auto-renewal-alert.component';
import { AutoRenewalSwitcherComponent } from 'mbs-ui-shared@components/licenses/components/auto-renewal-switcher/auto-renewal-switcher.component';
import { AwsTableComponent } from 'mbs-ui-shared@components/licenses/components/aws-table/aws-table.component';
import { DisableAutoRenewalModalComponent } from 'mbs-ui-shared@components/licenses/components/disable-auto-renewal-modal/disable-auto-renewal-modal.component';
import { EnableAutoRenewalModalComponent } from 'mbs-ui-shared@components/licenses/components/enable-auto-renewal-modal/enable-auto-renewal-modal.component';
import { ManageLicenseAdminModalComponent } from 'mbs-ui-shared@components/licenses/components/manage-license-admin-modal/manage-license-admin-modal.component';
import { ManageComputerModalComponent } from 'mbs-ui-shared@components/licenses/components/manage-license-computer-modal/manage-license-computer-modal.component';
import { PaymentMethodButtonComponent } from 'mbs-ui-shared@components/licenses/components/payment-method-button/payment-method-button.component';
import { ReleaseModalComponent } from 'mbs-ui-shared@components/licenses/components/release-modal/release-modal.component';
import { RenewLicenseModalComponent } from 'mbs-ui-shared@components/licenses/components/renew-license-modal/renew-license-modal.component';
import { RenewalTableComponent } from 'mbs-ui-shared@components/licenses/components/renewal-table/renewal-table.component';
import { WasabiTableComponent } from 'mbs-ui-shared@components/licenses/components/wasabi-table/wasabi-table.component';
import { LicensesPipesModule } from 'mbs-ui-shared@components/licenses/pipes/licenses-pipes.module';
import { SmartSearchTemplatesModule } from 'mbs-ui-shared@modules/smart-search-templates/smart-search-templates.module';
import { UtilsModule } from 'mbs-ui-shared@utils/utils.module';

const standaloneComponents = [
  AutoRenewalSwitcherComponent,
  EnableAutoRenewalModalComponent,
  DisableAutoRenewalModalComponent,
  ReleaseModalComponent,
  AutoRenewalAlertComponent
];
@NgModule({
  imports: [
    CommonModule,
    NgbDropdownModule,
    FormsModule,
    ButtonComponent,
    NgbModule,
    NgbTooltipModule,
    NgSelectModule,
    ReactiveFormsModule,
    UtilsModule,
    RouterModule,
    SmartSearchTemplatesModule,
    LicensesPipesModule,
    PaymentMethodButtonComponent,
    RmmDateTimeFormatModule,
    ManageComputerModalComponent,
    ManageLicenseAdminModalComponent,
    RenewLicenseModalComponent,
    RenewalTableComponent,
    AwsTableComponent,
    WasabiTableComponent,
    ...standaloneComponents
  ],
  exports: standaloneComponents,
  providers: [DatePipe]
})
export class LicensesSharedModule {}
